import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down-bold--sprite",
  "use": "arrow-down-bold--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"arrow-down-bold--sprite\"><path d=\"M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol